import * as React from 'react'
import * as Snippets from 'snippets'

export class ImageGridItem extends React.PureComponent<ImageGridItem.Props, ImageGridItem.State> {
  public constructor(props) {
    super(props)
  }


  public render(): JSX.Element {
    const { block, carouselToggle, classes } = this.props

    return (
      <div key={block.id} className={`${carouselToggle == true ? 'px-1 md:px-0 md:pr-2' : 'w-1/2'}`}>
        <div className={`${carouselToggle == true && 'w-full'}`}>
          {block.settings.src && (
            <a href={`${block?.settings?.linkurl ? block.settings?.linkurl : '#'}`}>
              <div className={`w-full ${carouselToggle == false ? classes : ''}`}>
                <Snippets.Image
                  loader={true}
                  alt={`${block.id}`}
                  src={block.settings.src}
                  ratio={'natural'}
                />
              </div>
            </a>
          )}
        </div>
        <div className='mt-1 uppercase'>
          {block.settings?.title?.title || block.settings?.title&& (
            <Snippets.Link
              className={'hover:underline'}
              title={block.settings?.title?.title || block.settings?.title}
              href={block?.settings?.linkurl ? block.settings?.linkurl : '#'}
            >{ block.settings?.title?.title || block.settings?.title }</Snippets.Link>
          )}
        </div>
      </div>
    )
  }
}

export namespace ImageGridItem {
  export interface Props {
    block: any
    carouselToggle: boolean
    classes: string
  }
  export interface State {
  }
}
